export default "__VITE_ASSET__BQeU8fo0__"